import gql from 'graphql-tag';
import { FULL_REPORT_FIELDS, FULL_REPORT_SYSTEM_FIELDS, FULL_REPORT_WITH_INSPECTION_SCOPE_ITEM_FIELDS } from '../schemas';

export const FETCH_REPORT = gql`
    ${FULL_REPORT_SYSTEM_FIELDS}
    ${FULL_REPORT_FIELDS}

    query report($id: ID!, $imageWidths: [Int!], $rotatedAttachmentDegrees:[Int!]) {
        report(id: $id, resizedAttachmentWidths: $imageWidths, rotatedAttachmentDegrees: $rotatedAttachmentDegrees) {
            ...FullReportFields
            originalReport {
                id
                reportSystems {
                    ...FullReportSystemFields
                }
            }
        }
    }
`;

export const FETCH_REPORT_WITH_INSPECTION_SCOPE_ITEMS = gql`
    ${FULL_REPORT_SYSTEM_FIELDS}
    ${FULL_REPORT_WITH_INSPECTION_SCOPE_ITEM_FIELDS}

    query report($id: ID!, $imageWidths: [Int!], $rotatedAttachmentDegrees:[Int!]) {
        report(id: $id, resizedAttachmentWidths: $imageWidths, rotatedAttachmentDegrees: $rotatedAttachmentDegrees) {
            ...FullReportWithInspectionScopeItemFields
            originalReport {
                id
                reportSystems {
                    ...FullReportSystemFields
                }
            }
        }
    }
`;
